<template>
  <div class="tail-price__cart-form tail-cart">
    <div
      v-if="cartItem"
      class="tail-cart__counter cart-counter">
      <button
        @click="downgradeCounts()"
        class="cart-counter__action cart-counter__action--minus" type="button">
        <i class="fa fa-minus"></i>
      </button>
      <div class="cart-counter__field">
        <input
          v-model="cartItem.quantity"
          type="text" class="cart-counter__input">
      </div>
      <button
        @click="upgradeCounts()"
        class="cart-counter__action cart-counter__action--plus" type="button">
        <i class="fa fa-plus"></i>
      </button>
    </div>
    <div
      v-if="!cartItem"
      class="tail-cart__action">
      <button
        @click="addItemToCart()"
        class="btn btn--primary tail-cart__btn"
        type="button">{{ btnValueText }}</button>
    </div>
    <div
      v-if="cartItem"
      class="tail-cart__action">
      <a
        href="/cart/"
        class="btn btn-link btn-link--success text-success"
        type="button">Добавлено</a>
    </div>
  </div>
</template>

<script>
import CartMixin from './mixins/CartMixin.vue'

export default {
  name: 'AddToCartTailBtn',
  props: {
    objectId: {
      type: Number,
      default: null
    },
    contentType: {
      type: Number,
      default: null
    },
    unitQuantity: {
      type: Number,
      default: 1
    },
    btnText: {
      type: String,
      default: 'В корзину'
    }
  },

  mixins: [CartMixin],

  watch: {
    $cart() {
      console.log(this.$cart)
      this.searchCartItem()
    }
  },

  mounted() {
    this.btnValueText = this.btnText
    this.searchCartItem()
  },

  data() {
    return {
      step: 'add-btn',
      btnValueText: 'В корзину',
      quantity: null,
      cartItem: null
    }
  },

  methods: {
    addItemToCart () {
      this.addToCart()
    },

    downgradeCounts () {
      this.deleteCountFromCart(this.cartItem)
    },
    
    upgradeCounts () {
      this.addCountToCart(this.cartItem)
    },

    searchCartItem () {
      if (this.$cart) {
        this.$cart.items.forEach(element => {
          if (element.content_type == this.contentType && element.object_id == this.objectId) {
            this.cartItem = element
          }
        })
      }
    }
  }
}
</script>

<style lang="scss"></style>
